 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		67: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		67: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-revie~634c0807","5":"promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","7":"buybox~quick-view~write-a-review-form","8":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~buybox","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~emt-generated-content","15":"media-gallery-overlay~media-gallery-overlay-mobile","16":"promotion-products-lazy~quick-view","17":"StoreLayout","18":"add-to-list-drawer","19":"aisle-bay","20":"augmented-reality","21":"bath-renovation","22":"breadcrumbs","23":"browse-and-search","24":"browse-and-search-mobile","25":"buybox","26":"calculator-pipcalculator","27":"collections","28":"collections-mobile","29":"compare","30":"consumer-card-messaging","31":"customer-image-overlay","32":"drawer","33":"emt-generated-content","34":"emt-links","35":"fbr","36":"global-custom-configurator","37":"hammerjs","39":"home","40":"magic-apron","41":"measurement-guide","42":"measurement-guide-overlay-content","43":"media-gallery-filmstrip-mobile","44":"media-gallery-overlay","45":"media-gallery-overlay-mobile","46":"message-types","47":"orange-lens","48":"order-sample","49":"order-sample-drawer","50":"overlay","51":"paint-reorder","52":"paint-reorder-mobile","53":"pep","54":"pep-mobile","55":"product","56":"product-mobile","57":"product-overview","58":"promotion-products-lazy","59":"question","60":"questions-and-answers","61":"quick-view","62":"ratings-and-reviews","63":"ratings-and-reviews-desktop","64":"ratings-and-reviews-mobile","65":"results","66":"returns-messaging","68":"share-to-email-overlay","69":"share-to-pinterest-overlay","70":"size-guide-overlay","71":"specifications","72":"stylequiz","73":"super-sku","74":"vendor-collection-products","75":"vendor-collections","76":"vendor-collections-mobile","78":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"64c14382e0fab35b6d9e","1":"21d6b24104a511f5931e","2":"c655823a675e28652240","3":"4a2d1622c4e82044bec2","4":"94cfb308bd08352b2f96","5":"8440eb9104542042b2ef","6":"3ee986cd677eb8fa15d0","7":"0392aef0d4a483a3d81f","8":"64831fcf8ec2624035b7","9":"b516c40f9f9e9ee63580","10":"29f7436096d9288cae20","11":"e6e0868d358b56e68e50","12":"e48be33ab12ba3978a24","13":"a9fc6b7bd26c6002cd39","14":"095baf400d873440705e","15":"ec6998d26b21953a0e3e","16":"2f2b1fb4b48f0c2a9b30","17":"5b93d9d8e570d162f1f4","18":"4e13f248cc6962ffb053","19":"bbd4dcc9b823a1c4586b","20":"fb0da1fbc3b6e15a6c4b","21":"132ea275d7becd88f1ea","22":"57e2fb4d87ed0a9d9f48","23":"2fb7601e8318eac8645b","24":"c3dd8c55e50c7c129e96","25":"23e5312ff42f1cd04df0","26":"4dea6cf1e968ac608324","27":"268a44db4ce722aefa9e","28":"6bfcbbc03585a9ca1337","29":"6f27739c10a8624be19c","30":"c1df9cba7ddf54810abd","31":"e6f06a1395c2d9685256","32":"0a6b3a4cc15f91c89acb","33":"6d8cdffa140f5040374d","34":"a49a9f3d206fb8355eaa","35":"bc50c5a04e2ed80ad5fa","36":"258cc06ef42d6a1a6598","37":"a8df4125bdc5402050c7","39":"76d6d0afb0290c7604fd","40":"36c4839c7c2e3d243350","41":"974ddd728fcac1dac9cc","42":"a30aeb8fbc6a6c1c74dd","43":"89c2e04c36c613b086e2","44":"6cfd782fd5957b8b2fa7","45":"690e91f3ef4a0e2a9d1b","46":"43c984eced72183435a4","47":"0961394c747c6f15b3b4","48":"3ff25312a8f026b949aa","49":"d01b64e1724dd0da7df0","50":"26791fbc32cf58f46c7f","51":"341195151742f7fc7e43","52":"1d13a737c27567d43ed7","53":"a56da327aa6caf0d4f1f","54":"d71b20970829dc2f7486","55":"0e302701e93738b6acd3","56":"ae06b57f5b393a3860f5","57":"c5c00f123ba650c099d4","58":"82e6d67f318901fb3626","59":"401c9c09288879fa600c","60":"84088f1be52c8443eb75","61":"18b7e0e71c1b0d8a4d38","62":"e6f3e5df597a4e65f561","63":"c3cc8f7b961100809100","64":"581e8220c0c287597b96","65":"7191f27f61573ccb5f6c","66":"f1491e7a4f18dd8a6ede","68":"5ab72ab83d10f9c556e7","69":"a0b8799830e4767182d8","70":"844c7e2882c8b63ddc01","71":"7fa638b5141132cd0947","72":"ad8f1ed7a8685ae547c9","73":"6f1f2c7a4cbc153772c1","74":"743683285c021695c56e","75":"5d77e21f415e46a7ee92","76":"fefab8fefd868bfd0814","78":"eb9d25a7d4503d820623"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"15":1,"16":1,"19":1,"23":1,"24":1,"25":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"35":1,"36":1,"40":1,"43":1,"44":1,"45":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"60":1,"61":1,"62":1,"64":1,"70":1,"72":1,"73":1,"74":1,"75":1,"76":1,"78":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-revie~634c0807","5":"promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","7":"buybox~quick-view~write-a-review-form","8":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","9":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~buybox","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~emt-generated-content","15":"media-gallery-overlay~media-gallery-overlay-mobile","16":"promotion-products-lazy~quick-view","17":"StoreLayout","18":"add-to-list-drawer","19":"aisle-bay","20":"augmented-reality","21":"bath-renovation","22":"breadcrumbs","23":"browse-and-search","24":"browse-and-search-mobile","25":"buybox","26":"calculator-pipcalculator","27":"collections","28":"collections-mobile","29":"compare","30":"consumer-card-messaging","31":"customer-image-overlay","32":"drawer","33":"emt-generated-content","34":"emt-links","35":"fbr","36":"global-custom-configurator","37":"hammerjs","39":"home","40":"magic-apron","41":"measurement-guide","42":"measurement-guide-overlay-content","43":"media-gallery-filmstrip-mobile","44":"media-gallery-overlay","45":"media-gallery-overlay-mobile","46":"message-types","47":"orange-lens","48":"order-sample","49":"order-sample-drawer","50":"overlay","51":"paint-reorder","52":"paint-reorder-mobile","53":"pep","54":"pep-mobile","55":"product","56":"product-mobile","57":"product-overview","58":"promotion-products-lazy","59":"question","60":"questions-and-answers","61":"quick-view","62":"ratings-and-reviews","63":"ratings-and-reviews-desktop","64":"ratings-and-reviews-mobile","65":"results","66":"returns-messaging","68":"share-to-email-overlay","69":"share-to-pinterest-overlay","70":"size-guide-overlay","71":"specifications","72":"stylequiz","73":"super-sku","74":"vendor-collection-products","75":"vendor-collections","76":"vendor-collections-mobile","78":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"122077d17b60cda2f019","1":"66bba79b70e3924b990e","2":"31d6cfe0d16ae931b73c","3":"aaa0137a65d448ed5f64","4":"7647b1510da5618b37af","5":"83588448fb37280fe4ec","6":"89d9163eeb30e835d559","7":"7647b1510da5618b37af","8":"0ef658ad0521bc70e648","9":"6fd9a33d658b6409b465","10":"50d430c72ccc3cf96a34","11":"7c2eed0c18c49e42c517","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"2d109bd7bcce838cd33b","16":"1616f1f6a954a81e19e4","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"86b1f984e52a6e02026d","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"62835b018b99e9533c60","24":"68da1228a2014ff4f6d3","25":"4e9211be1ce15f864da8","26":"31d6cfe0d16ae931b73c","27":"84f03d4a69cca886901d","28":"3f00e98f97268a984abf","29":"efe0cbab4890f136684d","30":"360d85a0ef189bc707ce","31":"c466036523aec2558c34","32":"fc73174b407ad863c497","33":"b49004ddac99adec2224","34":"31d6cfe0d16ae931b73c","35":"88e24c7aafcf93ae6cc6","36":"1a5562a08d12f7682989","37":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"ceebf150d8a696023a14","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"c185dd507b97bcc2bd63","44":"2a9848cae5d1e906880e","45":"788283886b0cd7f54141","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"6b54052876330d2b283a","51":"e0238b15111ec2d6d428","52":"879c34c541b6d51a616a","53":"ba0ccd99df0b817c1fdb","54":"0e6be6ff079493ae16ea","55":"a4dd7eabd7f3dc3b4395","56":"7c2359ffe09ff3fd6dde","57":"be155bb5d11dacdc4bb8","58":"d1bc438a4f81bc50b6ab","59":"31d6cfe0d16ae931b73c","60":"d70c859b20e57c1599c5","61":"02944920c1e50efac5f1","62":"8bab1a752ffbe17a3eb7","63":"31d6cfe0d16ae931b73c","64":"2ade42f7647d0b013747","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"453dfc2640779a848cc6","71":"31d6cfe0d16ae931b73c","72":"6c6bdd949ddd0752832b","73":"922dbc8ed510a58afe20","74":"e518e335254638969e62","75":"724bb466eb84c7c66b8b","76":"9d5d8e1e82b0331d024d","78":"42fb44e61b97c046a2eb"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
